import { SaveThresholdPayload, Threshold } from './models';

const actions = {
  LOAD_THRESHOLDS: '[DigitalTrapThresholds] Load Thresholds',
  LOAD_THRESHOLDS_SUCCESS: '[DigitalTrapThresholds] Load Thresholds Success',
  LOAD_THRESHOLDS_FAILURE: '[DigitalTrapThresholds] Load Thresholds Failure',
  SAVE_THRESHOLD: '[DigitalTrapThresholds] Save Threshold',
  SAVE_THRESHOLD_SUCCESS: '[DigitalTrapThresholds] Save Threshold Success',
  SAVE_THRESHOLD_FAILURE: '[DigitalTrapThresholds] Save Threshold Failure',
  DELETE_THRESHOLD: '[DigitalTrapThresholds] Delete Threshold',
  DELETE_THRESHOLD_SUCCESS: '[DigitalTrapThresholds] Delete Threshold Success',
  DELETE_THRESHOLD_FAILURE: '[DigitalTrapThresholds] Delete Threshold Failure',
  TOGGLE_THRESHOLD_MODAL: '[DigitalTrapThresholds] Toggle Modal',

  loadThresholds: () => ({
    type: actions.LOAD_THRESHOLDS
  }),
  loadThresholdsSuccess: (list: Threshold[]) => ({
    type: actions.LOAD_THRESHOLDS_SUCCESS,
    payload: list
  }),
  loadThresholdsFailure: (error: string) => ({
    type: actions.LOAD_THRESHOLDS_FAILURE,
    payload: error
  }),
  saveThreshold: (payload: SaveThresholdPayload) => ({
    type: actions.SAVE_THRESHOLD,
    payload
  }),
  saveThresholdSuccess: () => ({
    type: actions.SAVE_THRESHOLD_SUCCESS
  }),
  saveThresholdFailure: (error: string) => ({
    type: actions.SAVE_THRESHOLD_FAILURE,
    payload: error
  }),
  deleteThreshold: (id: string) => ({
    type: actions.DELETE_THRESHOLD,
    payload: id
  }),
  deleteThresholdSuccess: () => ({
    type: actions.DELETE_THRESHOLD_SUCCESS
  }),
  deleteThresholdFailure: (error: string) => ({
    type: actions.DELETE_THRESHOLD_FAILURE,
    payload: error
  }),
  toggleThresholdModal: (selected?: Threshold | null) => ({
    type: actions.TOGGLE_THRESHOLD_MODAL,
    payload: selected ?? null
  })
};

export default actions;
